module.exports = __webpack_public_path__ + "img/figure-13.63d0fde3.png";